import { Rate } from "antd";
import { useRouter } from "next/router";

import styles from "./FeaturedActsComponent.module.css";

export default function FeaturedActsComponent({ props, data }) {
  const router = useRouter();

  return (
    <section className={styles.featured_acts_container}>
      {data && data.length > 0 && (
        <div>
          <h2 className={styles.featured_acts_heading_text}>Featured Acts</h2>
          <ul
            className={`d-flex align-items-center  flex-wrap ${styles.featured_act_cards}`}
          >
            {data.map((item) => (
              <li
                className={styles.featured_act_card}
                key={item?._id}
                onClick={() => router.push(`/band/${item.slug}`)}
              >
                <figure className={styles.featured_act_card_figure}>
                  <img
                    src={
                      item?.image !== ""
                        ? process.env.IMAGE_LINK + item?.images
                        : process.env.IMAGE_LINK +
                          "assets/images/video_slide_two.png"
                    }
                    alt={`${item?.name}`}
                  />
                </figure>
                <div className={styles.featured_act_card_body}>
                  <h5 className={styles.featured_act_card_heading}>
                    {item?.name}
                  </h5>
                  <div className="d-flex justify-content-between flex-wrap">
                    <div
                      className={`d-flex align-items-center ${styles.featured_act_card_rating}`}
                    >
                      {item?.numberOfReviews > 0 &&
                      <Rate
                        allowHalf
                        defaultValue={item?.reviewRatings}
                        disabled
                        className={styles.featured_act_card_rating_star}
                      />}
                      {item?.numberOfReviews > 0 &&
                      <p className={styles.featured_act_card_rating_reviews}>
                        {item?.numberOfReviews} reviews
                      </p>}
                    </div>
                    <button className={styles.featured_act_card_explore_btn}>
                      Explore
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
